import { DollarSign, Download, Handshake, Home, Wallet } from 'lucide-react';
import Sidebar, { type SidebarProps } from './sidebar';

const sidebarItems = [
  { to: '/dashboard/home', icon: Home, label: 'sidebar.dashboard' },
  {
    to: '/dashboard/sub-affiliates',
    icon: Handshake,
    label: 'sidebar.subAffiliates',
  },
  {
    to: '/dashboard/commissions',
    icon: DollarSign,
    label: 'sidebar.commissions',
  },
  {
    to: '/dashboard/wallet',
    icon: Wallet,
    label: 'sidebar.wallet',
  },
  {
    to: '/dashboard/downloads',
    icon: Download,
    label: 'sidebar.downloads',
  },
];

type SidebarWithItemsProps = Omit<SidebarProps, 'items'>;

export function SidebarWithItems({
  ...props
}: SidebarWithItemsProps): JSX.Element {
  return <Sidebar items={sidebarItems} {...props} />;
}
